import { render, staticRenderFns } from "./pzList.vue?vue&type=template&id=37d330f8&scoped=true&"
import script from "./pzList.vue?vue&type=script&lang=js&"
export * from "./pzList.vue?vue&type=script&lang=js&"
import style0 from "./pzList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pzList.vue?vue&type=style&index=1&id=37d330f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d330f8",
  null
  
)

export default component.exports